/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "heLambdaNotifyUserOfEventApi",
            "endpoint": "https://4nsf601obe.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        },
        {
            "name": "heLambdaPublicQueryApi",
            "endpoint": "https://5ghr6yi2v8.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        },
        {
            "name": "heManageUserApi",
            "endpoint": "https://hbb6tvk71g.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://7j7qqrxmjzehtey3ctw7hy2fem.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-cuxbnql6wncilmag4vmubfp2qy",
    "aws_cognito_identity_pool_id": "eu-west-2:f0a65b6d-3aed-4bfe-9dca-7daa677cf20f",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_oWI2U7Lg7",
    "aws_user_pools_web_client_id": "39po63hqs75nfrf2nsjs6cs524",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "healthyemployee-healthyevents-app-storage182058-master",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
